import { render, staticRenderFns } from "./GroupsSelector.vue?vue&type=template&id=789d2354&scoped=true&"
import script from "./GroupsSelector.vue?vue&type=script&lang=ts&"
export * from "./GroupsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./GroupsSelector.vue?vue&type=style&index=0&id=789d2354&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "789d2354",
  null
  
)

export default component.exports